import { Field as FormikField } from 'formik';
import styled from 'styled-components';

export const Field = styled(FormikField)``;
